import {
  Component, ChangeDetectionStrategy,
} from '@angular/core'

@Component({
  selector: 'kb-panel-header',
  templateUrl: './panel-header.component.html',
  styleUrls: ['./panel-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class PanelHeaderComponent {
}
